import React, { useContext, useEffect } from "react";
import { StoreContext } from "../../store/Store";
import Loader from "../Loader/Loader";
import { GoLinkExternal } from "react-icons/go";
import { Link } from "react-router-dom";
import { encrypt } from "../../Utils/Encryption";
import DashboardPieChart from "../../charts/DashboardPieChart";
import DashboardBarChart from "../../charts/DashboardBarChart";
import DashboardLineChart from "../../charts/DashboardLineChart";
import DashboardDonutChart from "../../charts/DashboardDonutChart";

const MainDashboardChartComponent = () => {
  const { database, getLevel0Metrics, level0Metrics } =
    useContext(StoreContext);

  useEffect(() => {
    const configid = localStorage.getItem("configid");
    getLevel0Metrics(configid);
  }, []);

  console.log(level0Metrics);

  const renderChart = (chartType, metricData, i) => {
    switch (chartType) {
      case "Bar Chart":
        return <DashboardBarChart key={i} metricData={metricData} />;
      case "Pie Chart":
        return <DashboardPieChart key={i} metricData={metricData} />;
      case "Donut Chart":
        return <DashboardDonutChart key={i} metricData={metricData} />;
      case "Line Chart":
        return <DashboardLineChart key={i} metricData={metricData} />;
      default:
        return <p key={i}>No chart type found for {chartType}</p>;
    }
  };

  console.log(level0Metrics)

  if (level0Metrics == null) {
    return <Loader />;
  }

  return (
    <div className="dashboard">
      <div className="level0Metrics row g-3">
        {level0Metrics
          .filter(
            (filterItem) =>
              filterItem.value && Object.keys(filterItem.value).length > 0
          )
          .map((item, i) => (
            <div className="level0Metric col-12 col-md-6" key={i}>
              {renderChart(item.chart_type, item, i)}
            </div>
          ))}
      </div>
    </div>
  );
};

export default MainDashboardChartComponent;
